import React from 'react'

import { Helmet } from 'react-helmet'

import './test.css'

const Test = (props) => {
  return (
    <div className="test-container">
      <Helmet>
        <title>Test - IEES Landing Page</title>
        <meta property="og:title" content="Test - IEES Landing Page" />
      </Helmet>
    </div>
  )
}

export default Test
